import {NgModule} from "@angular/core";
import {ClickableElementDirective} from "./clickable.element.directive";

@NgModule({
	declarations: [ClickableElementDirective],
	exports: [ClickableElementDirective],
})
export class ClickableElementModule {
}
